/**
 * One height for both conversation modals, always.
 *
 * Sizing to the content makes them jump: the new-conversation list moves the
 * tabs and the search field under the cursor between keystrokes as the search
 * narrows, and the details panel opens as a short box holding a spinner and
 * then snaps to full size the moment the members arrive.
 *
 * `min` keeps it inside the viewport on a short screen, where `ModalPortal`'s
 * own `calc(90vh - 85px)` ceiling would otherwise clip it.
 *
 * The viewport it measures is `--app-vh`, the VISIBLE height the chat page
 * publishes (see `useVisualViewportHeight`), not `vh`: on a phone `vh` stays
 * the full screen while the keyboard is up, and a modal sized against it keeps
 * its lower half - the very field being typed into - behind the keys. The
 * fallback makes the expression exactly the old `90vh` wherever the variable
 * is not published. The 85px is the modal header.
 */
export const CONVERSATION_MODAL_HEIGHT =
  'min(560px, calc(var(--app-vh, 100vh) * 0.9 - 85px))';
